import { useCallback, useContext, useEffect } from 'react';

import { useAssignmentLazyQuery } from '../../generated/graphql_offer';
import { context as dependencyContext } from '../../view/context/dependency';

export const useAssignment = () => {
  const { errorPresenter, offerApiClient } = useContext(dependencyContext);
  const [getAssignment, { data, loading, error, refetch }] = useAssignmentLazyQuery({ client: offerApiClient });

  const load = useCallback(
    (assignmentId: string) => {
      getAssignment({ variables: { id: assignmentId } });
    },
    [getAssignment],
  );

  useEffect(() => {
    if (error) {
      errorPresenter.showAsNonFatal(error);
    }
  }, [errorPresenter, error]);

  return {
    loadAssignment: load,
    dataAssignment: data,
    loadingAssignment: loading,
    errorAssignment: error,
    refetchAssignment: refetch,
  };
};
